export default async function handler(req, res) {
  if (req.method !== 'POST') {
    return res.status(405).json({ error: 'Nur POST erlaubt' });
  }

  const { imageBase64 } = req.body;

  if (!imageBase64) {
    return res.status(400).json({ error: 'Kein Bild übermittelt' });
  }

  try {
    const response = await fetch('https://api.openai.com/v1/chat/completions', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        model: 'gpt-4-vision-preview',
        messages: [
          {
            role: 'user',
            content: [
              { type: 'text', text: 'Schätze die Nährwerte dieses Gerichts pro 100g. Gib bitte Kalorien, Eiweiß, Fett, Kohlenhydrate, Ballaststoffe, Kaloriendichte (kcal/100g) und Sättigungsscore (1–10) im Format:\nKalorien: ...\nEiweiß: ...\n... aus.' },
              {
                type: 'image_url',
                image_url: {
                  url: imageBase64,
                },
              },
            ],
          },
        ],
        max_tokens: 500,
      }),
    });

    const data = await response.json();
    return res.status(200).json(data);
  } catch (error) {
    console.error('Fehler bei GPT-Anfrage:', error);
    return res.status(500).json({ error: 'Fehler bei GPT-Anfrage' });
  }
}

